<template>
  <div>
    <div id="smalldisplaylist_filter">
    <TableActionHeader @filterChange="(val) => {this.filter = val}" :newButton=false></TableActionHeader>
    </div>
        <b-table 
            hover 
            striped 
            :items="displayList" 
            :fields="fields"
            :responsive="false"
            :small="true"
            primary-key="id"
            ref="displayList"
            selectable selection-mode="multi"
            @row-selected="onRowSelected"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :per-page="perPage"
            :current-page="currentPage"
            >
            <template v-slot:cell(id)="data">
               <span>{{ data.value }}</span>
            </template>
            <template v-slot:cell()="data">
                <span class="listNameText"><p class="listNameParag">{{ data.item.name }}</p></span>
            </template>
        </b-table>
        <div class="d-flex justify-content-center">
        <TablePagination :perPage="perPage" :totalRows="totalRows" @pageChange="(p)=>{this.currentPage = p}"></TablePagination>
       </div>
  </div>
</template>

<script>
export default {
  name: 'SmallDisplayList',
  props: {
    dontShow: Array,
    perPage: { default: 10 }
  },
  data: function() {
        return {
            fields: [ 
            //{key:'status',label:'', sortable: true },
            {key:'id',label:'Id', sortable: true },
            {key:"name",label:"Name", sortable: true },
            ],
            currentPage: 1,
            selected: [],
            listData: [],
            listLength: 0,
            pagingPerPage: 5,
            filter: null,
            filterOn: ['id','name']
        }
  },
  computed: {
    displayList(){
      var list = [];
      if(this.dontShow && this.dontShow.length > 0){
         const self = this;
         this.listData.forEach(function (display) {
            if(!self.dontShow.includes(display.id))
              list.push(display);
        });
        
      }
      else {
        list = this.listData;
      }
      
      return list;
    },
    totalRows(){
      return this.displayList.length
    }
  },
  mounted: function() {
    this.getDisplayListData();
  },
  methods: {
    getDisplayListData() {
   
      const vm = this;
      //this.$traveller_http.get('/traveller/restui/display/listDisplays')
      this.$traveller_http.get('/traveller/restui/content/timetableview/list')
         .then(function(resp) {
             if(resp.data.code !== undefined) {
               return;
             }
             
             vm.listData = resp.data;
             vm.listLength = resp.data.length;
             
         })
    },
    onRowSelected(items) {
      this.selected = items
    },
    deselectAll() {
      this.$refs.displayList.clearSelected();
    },
    getDisplayList() {
      return JSON.parse(JSON.stringify(this.listData));
    },
    getSelectedList() {
      return JSON.parse(JSON.stringify(this.selected));
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
p {
  margin-bottom: 0.1rem;
}
p .listNameParag {
  margin-bottom: 0.1rem;
}
.listNameText {
  font-weight: bold;
}
.listLabelText {
  font-style: italic;
  padding-left: 1em;
}
</style>
